import "lazysizes";
import Scrollbar from 'smooth-scrollbar';

if ($(".scrollArticle").length > 0) {
  scrollbars['article'] = Scrollbar.init($(".scrollArticle")[0], {
    alwaysShowTracks: true
  })  
}
 